import {AfterViewInit, ChangeDetectorRef, Component, DoCheck, KeyValueDiffers, OnInit} from '@angular/core';
import {DataSharingService} from '../services/data-sharing.service';
import {ApiService} from '../services/api.service';
import {LoaderService} from '../shared/loader/loader-service.services';
import {UtilService} from '../services/UtilService';
import {Router} from '@angular/router';
import {RangeDateScreenerFilterModel} from '../modals/RangeDateScreenerFilterModel';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Store} from '@ngxs/store';
import {SaveStateName} from '../ngxs/screener-filter.action';

@Component({
  selector: 'app-iboxx-index-details-page',
  templateUrl: './iboxx-index-details-page.component.html',
  styleUrls: ['./iboxx-index-details-page.component.scss']
})
export class IboxxIndexDetailsPageComponent implements OnInit, DoCheck, AfterViewInit {

  tabList: string[] = [];
  currentTab = '';
  currentID = '';
  indexType = 'all';
  currentBatchData = [];
  response: any = undefined;
  chartDataLoaded = false;
  chartType = 'single';
  chartSetting = 'default';
  chartDataFetching = false;
  currentPeriod = '';
  currentTimeSeries = '';
  chartData = {
    chartSeries: {
      data: [],
      max: null,
      min: null,
      name: this.currentTimeSeries,
      unit: null
    },
    selectedPeriod: '',
    selectedTimeSeries: ''
  };
  chartDatas = [];
  profileData: any;
  profileLoading = false;
  constituentData: any;
  dateRange: RangeDateScreenerFilterModel = new RangeDateScreenerFilterModel();
  periodData = ['YTD', '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y'];
  period: any;
  timeSeriesData = ['Total Return Index Level', 'Price Return Index Level'];
  timeSeries: any;
  compareData: any;
  resetDropdown = false;
  indexToCompare = [''];
  TRSIndex = [];
  cards = ['CHART', 'INDEX PROFILE', 'INDEX PERFORMANCE & ANALYTICS'];
  visibleCards = ['chart', 'profile', 'analytics', 'constituent'];
  selectedTimeSeries = '';
  selectedPeriod = '';
  selectedFromDate = '';
  selectedToDate = '';
  expanded = false;
  currentCard = '';
  currentView = [];

  // ALERT VIEW
  showAlert1 = false;
  showAlert2 = false;
  showAlert3 = false;
  alert1 = '';
  alert2 = '';
  alert3 = '';
  alertType = 'info';
  indexNotInHeadline = false;
  indexNotFoundMsg = 'Invalid Request.';
  chartFilters = [];
  differ: any;


  constructor(private shareService: DataSharingService, private loader: LoaderService, private apiService: ApiService,
              public utilService: UtilService, private route: Router, private differs: KeyValueDiffers, private cdRef: ChangeDetectorRef,
              private store: Store) {
    this.differ = this.differs.find({}).create();
    this.store.select(state => state.indexState.stateName).subscribe((resp: any) => {
      this.indexType = resp.trim() === '' || resp.trim() === 'emix' ? 'all' : resp;
    });
    const batchDataSub = this.shareService.currentBatch.subscribe((data: any) => {
      this.currentBatchData = data;
      this.currentBatchData = this.currentBatchData.concat(this.shareService.searchedData);
    });
    if (batchDataSub) {
      batchDataSub.unsubscribe();
    }
    this.initialiseDropDown();
  }

  ngOnInit(): void {
    // @ts-ignore
    const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
      {
        all: [],
        futures: [],
        trs: [],
        esg: [],
      };
    this.tabList = tabGroup[this.indexType].length > 0 ? tabGroup[this.indexType] : ['screener', 'documentation'];

    // @ts-ignore
    this.currentView = JSON.parse(localStorage.getItem('tabViewState')) ? JSON.parse(localStorage.getItem('tabViewState')) : [];
    this.currentTab = this.shareService.currentTab;
    // @ts-ignore
    this.chartFilters = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];

    const urlSub = this.shareService.indexURL.subscribe((resp: any) => {
      this.currentID = resp.split('=')[1];
      if (this.isValidIndex(this.currentID)) {
        this.fetchChartOptions();
        this.fetchDetailsForID(this.currentID);
        if (this.currentTab.length > 0) {
          if (this.currentView.find((view: any) => view.tabName === this.currentTab)) {
            this.repopulateView();
          } else {
            this.storeView();
          }
        }
      } else {
        this.indexNotInHeadline = true;
        this.loader.hide();
      }
    });
    if (urlSub) {
      urlSub.unsubscribe();
    }
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.chartData);
    if (change) {
      this.chartDataLoaded = false;
      const elem = document.getElementsByClassName('no-data-display')[0];
      if (elem) {
        elem.remove();
      }
      setTimeout(() => {
        this.chartDataLoaded = true;
      }, 10);
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  isValidIndex(indexID: string): boolean {
    return this.shareService.headlineIndices.findIndex((index: any) => index.id === indexID) > -1;
  }

  initialiseDropDown(): void {
    this.period = {
      label: '',
      options: []
    };
    this.timeSeries = {
      label: '',
      options: []
    };
    this.compareData = {
      label: '',
      options: []
    };
  }

  initDropDown(): void {
    this.period.options.push({
      label: 'No period selected',
      value: 'No period selected',
      selected: false
    });
    this.periodData.forEach((pd: string) => {
      this.period.options.push({
        label: pd,
        value: pd,
        selected: pd === (this.selectedPeriod ? this.selectedPeriod : this.periodData[0])
      });
    });
    this.initTimeSeriesDropDown();
  }

  setDateRange(event: any): void {
    if (event.ngbFromDate && event.ngbToDate) {
      const from = event.ngbFromDate.month + '/' + event.ngbFromDate.day + '/' + event.ngbFromDate.year;
      const to = event.ngbToDate.month + '/' + event.ngbToDate.day + '/' + event.ngbToDate.year;
      const maxDate = event.maxDate.month + '/' + event.maxDate.day + '/' + event.maxDate.year;
      const minDate = event.minDate.month + '/' + event.minDate.day + '/' + event.minDate.year;
      if (!isNaN(new Date(from).getTime()) && !isNaN(new Date(to).getTime())
        && (new Date(from).getTime() >= new Date(minDate).getTime())
        && (new Date(to).getTime() <= new Date(maxDate).getTime())) {
        this.currentPeriod = 'custom';
        this.reinitialisePeriodPicker();
        // @ts-ignore
        const validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate()) - new Date(from)) <= 0;
        if (validPeriod) {
          this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, to, from, this.chartType, this.indexToCompare);
          if (this.chartType === 'multi') {
            this.fetchChartDataToCompareFor();
          } else {
            this.fetchCustomChartDataFor(this.response.id, from, to);
          }
        } else {
          this.indexNotFoundMsg = 'Can only select period within last 10 years.';
          this.indexNotInHeadline = true;
        }
      }
    }
  }

  getIndexValue(index: string): void {
    // this.currentTab = index;
    this.expanded = false;
    if (index === 'screener') {
      switch (this.indexType) {
        case 'all':
          this.route.navigateByUrl('iBoxx/Screener');
          break;
        case 'futures':
          this.route.navigateByUrl('iBoxx/Futures/Screener');
          break;
        case 'trs':
          this.route.navigateByUrl('iBoxx/TRS/Screener');
          break;
        case 'esg':
          this.route.navigateByUrl('iBoxx/ESG/Screener');
          break;
      }
    } else if (index === 'documentation') {
      switch (this.indexType) {
        case 'all':
          this.route.navigateByUrl('Indices/docs/page?docFor=iBoxx');
          break;
        case 'futures':
          this.route.navigateByUrl('Futures/docs/page?docFor=iBoxx');
          break;
        case 'trs':
          this.route.navigateByUrl('TRS/docs/page?docFor=iBoxx');
          break;
        case 'esg':
          this.route.navigateByUrl('ESG/docs/page?docFor=iBoxx');
          break;
      }
    } else if (index === 'trs calculator'){
      this.route.navigateByUrl('iBoxx/TRS/Calculator');
    }else {
      // if (this.response.indexName !== index.split('?')[0]) {
      if (this.currentTab !== index) {
        this.repopulateView();
        window.location.href = window.location.href.split('=')[0] + '=' +
          this.shareService.headlineIndices.find((data: any) =>
            data.indexName === index.split('?')[0] && data.inflationAdjustment === index.split('?')[1]).id;
      }
    }
  }

  fetchDetailsForID(identifier: string): void {
    this.loader.show();
    this.apiService.getISINDetailsFor(identifier).subscribe((resp: any) => {
      if (resp.error) {
        this.showAlert1 = true;
        this.alert1 = resp.errorMessage;
      } else {
        this.response = resp.indexDetails;
        this.currentTab = this.response.indexName + '?' + this.response.inflationAdjustment;
        this.getTabList();
        this.timeSeriesData.splice(2, 1, this.response.assetType === 'bond' ? 'Annual Yield (%)' : 'Current Yield (%)');
        this.initTimeSeriesDropDown();
        this.initCompareChartDropdown();
        if (this.response?.investmentType !== null &&
          (this.response?.investmentType.includes('ETFs_FUNDs') || this.response?.investmentType.includes('Standardized_TRS') || this.response?.investmentType.includes('Futures'))) {
          this.cards.push('CONSTITUENT');
          if (this.response?.investmentType.includes('Standardized_TRS') || this.response?.investmentType.includes('Futures')) {
            this.rePopulateTimeSeriesDropDown();
          }
        } else {
          if (this.cards.includes('CONSTITUENT')) {
            this.cards.splice(this.cards.indexOf('CONSTITUENT'), 1);
          }
        }
        this.fetchIndexProfileFor(identifier);
        // UPDATING TIMESERIES VALUE FOR LOAN/BOND INDEX
        this.repopulateView();
      }
    });
    if ((this.selectedPeriod !== null && this.selectedPeriod.length > 0) &&
      (this.selectedTimeSeries !== null && this.selectedTimeSeries.length > 0)) {
      if (this.selectedPeriod === 'custom') {
        this.dateRange.ngbFromDate = new NgbDate(new Date(this.selectedFromDate).getFullYear(),
          new Date(this.selectedFromDate).getMonth() + 1, new Date(this.selectedFromDate).getDate());
        this.dateRange.ngbToDate = new NgbDate(new Date(this.selectedToDate).getFullYear(),
          new Date(this.selectedToDate).getMonth() + 1, new Date(this.selectedToDate).getDate());
        this.reinitialisePeriodPicker();
        this.currentPeriod = this.selectedPeriod;
        if (this.chartType === 'multi') {
          this.fetchChartDataToCompareFor();
        } else {
          this.fetchCustomChartDataFor(identifier, this.selectedFromDate, this.selectedToDate);
        }
      } else {
        if (this.chartType === 'multi') {
          this.fetchChartDataToCompareFor();
        } else {
          this.fetchChartDataFor(identifier, this.selectedPeriod, this.selectedTimeSeries.replace(' (%)', '').replace(' (bps)', ''));
        }
      }
    } else {
      this.fetchChartDataFor(identifier, this.periodData[0], this.timeSeriesData[0].replace(' (%)', '').replace(' (bps)', ''));
    }

  }

  applyPeriodFilter(): void {
    this.currentPeriod = this.period.options.find((option: any) => {
      if (option.selected) {
        return option;
      }
    }).label;
    if (this.currentPeriod === 'No period selected') {
      if (!this.dateRange.ngbFromDate && !this.dateRange.ngbToDate) {
        this.removeChart();
      } else {
        this.currentPeriod = 'custom';
      }
    }
    if (this.chartType === 'multi' && this.currentPeriod !== 'custom') {
      this.dateRange = new RangeDateScreenerFilterModel();
      this.fetchChartDataToCompareFor();
    } else if (this.currentID.length > 0 && this.currentPeriod !== 'custom' && this.currentPeriod !== 'No period selected' &&
      (this.chartType || this.chartType === 'single')) {
      this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''));
    }
    this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, '', '', this.chartType, this.indexToCompare);
  }

  applyTimeSeriesFilter(): void {
    this.currentTimeSeries = this.timeSeries.options.find((option: any) => {
      if (option.selected) {
        return option;
      }
    }).label;
    this.chartSetting = this.currentTimeSeries === 'Total Return Index Level' && this.indexToCompare.length === 1 ? 'default' : 'custom';
    let from = '';
    let to = '';
    if (this.dateRange.ngbFromDate && this.dateRange.ngbFromDate) {
      // @ts-ignore
      from = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year;
      // @ts-ignore
      to = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
    }
    // @ts-ignore
    let validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate()) - new Date(from)) <= 0;
    if (this.currentPeriod !== 'custom'){
      validPeriod = true;
    }
    if (validPeriod) {
      if (this.currentPeriod === 'custom' || this.currentPeriod === 'No period selected') {
        this.loader.show();
        if (this.chartType === 'multi') {
          this.fetchChartDataToCompareFor();
        } else {
          this.fetchCustomChartDataFor(this.currentID, from, to);
        }
      } else {
        if (this.currentID.length > 0) {
          if (this.chartType === 'multi') {
            this.fetchChartDataToCompareFor();
          } else {
            this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''));
          }
        }
      }
      this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, to, from, this.chartType, this.indexToCompare);
    }else{
      this.indexNotFoundMsg = 'Can only select period within last 10 years.';
      this.indexNotInHeadline = true;
    }
    this.rePopulateCompareIndexDropDown();
  }

  compareCharts(event: any): void {
    const selectedIndices = event.map((ev: any) => ev.value);
    this.indexToCompare = this.TRSIndex.filter((index: any) => selectedIndices.includes(index.indexName)).map((index: any) => index.id);
    this.indexToCompare = [this.currentID , ...this.indexToCompare];
    this.chartSetting = this.indexToCompare.length > 1 ? 'custom' : 'default';
    let from = '';
    let to = '';
    if (this.dateRange.ngbFromDate && this.dateRange.ngbFromDate) {
      // @ts-ignore
      from = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year;
      // @ts-ignore
      to = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
    }

    // @ts-ignore
    let validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate()) - new Date(from)) <= 0;
    if (this.currentPeriod !== 'custom'){
      validPeriod = true;
    }
    if (validPeriod) {
      this.indexNotInHeadline = false;
      this.chartType = this.indexToCompare.length > 1 ? 'multi' : 'single';
      this.fetchChartDataToCompareFor();
      this.rePopulateTimeSeriesDropDown();
      this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, to, from, this.chartType, this.indexToCompare);
    } else {
      this.indexNotFoundMsg = 'Can only select period within last 10 years.';
      this.indexNotInHeadline = true;
    }
  }

  resetChart(): void{
    this.chartSetting = 'default';
    this.currentPeriod = 'YTD';
    this.selectedPeriod = 'YTD';
    this.currentTimeSeries = 'Total Return Index Level';
    this.selectedTimeSeries = 'Total Return Index Level';
    this.chartType = 'single';
    this.indexToCompare = [this.currentID];
    this.resetDropdown = false;
    this.initialiseDropDown();
    this.initDropDown();
    if (this.response?.investmentType.includes('Standardized_TRS') || this.response?.investmentType.includes('Futures')) {
      this.rePopulateTimeSeriesDropDown();
    }
    this.initCompareChartDropdown();
    this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
    this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, '', '', this.chartType, this.indexToCompare);
  }

  fetchChartDataToCompareFor(): void {
    if (this.indexToCompare === undefined || this.indexToCompare.length === 0) {
      this.chartType = 'single';
      this.utilService.removeChartFilerOptionFor(this.currentID);
      this.fetchChartDataFor(this.response.id, this.currentPeriod, this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''));
    } else if (this.indexToCompare.length <= 5) {
      if (!this.chartDataFetching) {
        this.loader.show();
        this.chartDataLoaded = false;
        this.chartDataFetching = true;
        this.chartSetting = 'custom';
        let from = '';
        let to = '';
        if (this.dateRange.ngbFromDate && this.dateRange.ngbFromDate) {
          // @ts-ignore
          from = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year;
          // @ts-ignore
          to = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
        }

        this.apiService.getChartDataToCompareFor(this.indexToCompare.join('~'), this.currentPeriod,
          from, to,
          this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''))
          .subscribe((resp: any) => {
          if (resp.error) {
            this.showAlert2 = true;
            this.alert2 = resp.errorMessage;
            this.chartType = 'single';
            this.resetDropdown = false;
            this.initCompareChartDropdown();
            this.utilService.removeChartFilerOptionFor(this.currentID);
          } else {
            this.chartDataLoaded = true;
            this.chartDatas = resp.chartDatas;
          }
          this.chartDataFetching = false;
          this.loader.hide();
        });
      }
    } else {
      this.indexNotFoundMsg = 'Maximum 5 indices can be displayed on chart.';
      this.indexNotInHeadline = true;
    }
  }

  fetchChartDataFor(indexID: string, period: string, timeSeries: string): void {
    if (!this.chartDataFetching && indexID) {
      this.chartDataLoaded = false;
      this.chartDataFetching = true;
      this.loader.show();
      if (this.currentPeriod !== 'custom') {
        this.dateRange = new RangeDateScreenerFilterModel();
      }
      if (period === 'No period selected') {
        this.removeChart();
      } else {
        this.chartSetting = period === 'YTD' && timeSeries === 'Total Return Index Level' && this.indexToCompare.length === 1 ? 'default' : 'custom';
        this.apiService.getChartDataFor(indexID, period, timeSeries)
          .subscribe((resp: any) => {
            if (resp.error) {
              this.showAlert2 = true;
              this.alert2 = resp.errorMessage;
              this.chartType = 'single';
              this.utilService.removeChartFilerOptionFor(this.currentID);
            } else {
              this.chartDataLoaded = true;
              this.chartType = 'single';
              this.chartData = resp.chartData;
              this.dateRange = new RangeDateScreenerFilterModel();
            }
            this.chartDataFetching = false;
            this.loader.hide();
          });
      }
    }
  }

  fetchCustomChartDataFor(indexId: string, from: string, to: string): void {
    this.chartDataFetching = true;
    this.chartDataLoaded = false;
    this.chartSetting = 'custom';
    this.loader.show();
    this.apiService.getCustomChartDataFor(indexId, from, to, this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''))
      .subscribe((resp: any) => {
      if (resp.error) {
        this.showAlert2 = true;
        this.alert2 = resp.errorMessage;
        this.chartType = 'single';
        this.utilService.removeChartFilerOptionFor(this.currentID);
      } else {
        this.chartType = 'single';
        this.chartData = resp.chartData;
        this.chartDataLoaded = true;
      }
      this.chartDataFetching = false;
      this.loader.hide();
    });
  }

  removeChart(): void {
    this.loader.show();
    setTimeout(() => {
      if (this.chartData) {
        this.chartData.chartSeries.data = [];
        this.chartData.chartSeries.name = this.currentTimeSeries;
        this.chartDataLoaded = false;
      }
      this.chartDataFetching = false;
      this.loader.hide();
    }, 1000);
  }

  fetchIndexProfileFor(indexID: string): void {
    this.profileData = undefined;
    this.constituentData = undefined;
    this.profileLoading = true;
    this.apiService.getConstituentData(indexID).subscribe((resp: any) => {
      if (resp.error) {
        this.showAlert3 = true;
        this.alert3 = resp.errorMessage;
      } else {
        this.profileLoading = false;
        if (this.response?.investmentType !== null &&
          (this.response?.investmentType.includes('ETFs_FUNDs') || this.response?.investmentType.includes('Standardized_TRS') || this.response?.investmentType.includes('Futures'))) {
          this.constituentData = resp.constituentsList;
        }
        let hasValue = false;
        Object.keys(resp.constituentData).forEach(key => {
          if (resp.constituentData[key]) {
            hasValue = true;
          }
        });
        this.profileData = hasValue ? resp.constituentData : undefined;
      }
    });
  }

  downloadHistory(): void {
    this.loader.show();
    if (this.currentPeriod === 'No period selected') {
      this.downloadAsCSV(undefined, this.currentTimeSeries);
      this.loader.hide();
    } else if (this.currentPeriod === 'custom') {
      // @ts-ignore
      const from = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year;
      // @ts-ignore
      const to = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
      // @ts-ignore
      const validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate()) - new Date(from)) <= 0;
      if (validPeriod) {
        if (this.chartType === 'multi') {
          if (this.indexToCompare.length <= 5) {
            this.apiService.getDataToDownloadForIndices(this.indexToCompare.join('~'), this.currentPeriod, from, to,
              this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''),
              this.getFileName(this.currentTimeSeries));
            this.loader.hide();
          } else {
            this.indexNotFoundMsg = 'Maximum 5 indices data can be downloaded.';
            this.indexNotInHeadline = true;
            this.loader.hide();
          }
        } else {
          this.apiService.getDataToDownloadForCustom(this.currentID, from, to,
            this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''),
            this.getFileName(this.currentTimeSeries));
          this.loader.hide();
        }
      } else {
        this.indexNotFoundMsg = 'Can only select period within last 10 years.';
        this.indexNotInHeadline = true;
        this.loader.hide();
      }
    } else {
      if (this.chartType === 'multi') {
        if (this.indexToCompare.length <= 5) {
          this.apiService.getDataToDownloadForIndices(this.indexToCompare.join('~'), this.currentPeriod, '', '',
            this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''),
            this.getFileName(this.currentTimeSeries));
          this.loader.hide();
        } else {
          this.indexNotFoundMsg = 'Maximum 5 indices data can be downloaded.';
          this.indexNotInHeadline = true;
          this.loader.hide();
        }
      } else {
        this.apiService.getDataToDownload(this.currentID, this.currentPeriod,
          this.currentTimeSeries.replace(' (%)', '').replace(' (bps)', ''),
          this.getFileName(this.currentTimeSeries));
        this.loader.hide();
      }
    }
  }

  downloadAsCSV(resp: any, currentTimeSeries: string): void {
    // const headerList = ['Date', 'ISIN', 'Name', currentTimeSeries];
    // const dataToExport = this.utilService.convertToCSV(this.response.isinTri, this.response.indexName,
    //   headerList, resp ? resp.chartData.chartSeries.data : []);
    const fileName = this.response.indexName + '_' +
      ((this.currentPeriod === '3Y' || this.currentPeriod === '5Y' || this.currentPeriod === '10Y') ? '1Y' : this.currentPeriod)
      + '_' + currentTimeSeries.replace(' (%)', '').replace(' (bps)', '') + '_'
    + (this.response.productName === 'iBoxx Global Inflation-linked' ? this.response.inflationAdjustment : '');
    const URL = this.apiService.createGetPath('/indices/createExcel', ['fileName', encodeURIComponent(fileName)]);
    window.open(URL);
    // this.utilService.downloadFile(dataToExport, fileName);
  }

  downloadConstituentData(): void {
    const fileName = encodeURIComponent(this.response.indexName.replaceAll('/', ' ') + '_constituentData');

    // const headerList = ['Report Date', 'Rebalance Date', 'Issuer', 'Coupon in %', 'Maturity Date', 'Index Weight in %'];
    // const dataToExport = this.utilService.convertConstituentDataToCSV(headerList, this.constituentData);
    // this.utilService.downloadFile(dataToExport, fileName);
    this.loader.show();
    this.apiService.getConstituentDataToDownload(this.response.id, this.response.assetType,
      fileName);
    this.loader.hide();
  }

  downloadDataForIndicesAsCSV(): void {
    // const header1 = ['Performance Indicator:', resp.chartDatas[0].selectedTimeSeries];
    // const dataToDownload: any[] = [];
    // // @ts-ignore
    // dataToDownload.Date = resp.chartDatas[0].chartSeries.data.map((dt: any) => dt.date);
    // resp.chartDatas.forEach((data: any) => {
    //   dataToDownload[data.chartSeries.name] = data.chartSeries.data.map((dt: any) => dt.value);
    // });
    // const headerList: string[] = [];
    // Object.keys(dataToDownload).forEach((key: string) => headerList.push(key));
    // const dataToExport = this.utilService.convertMultipleIndexDataToCSV(header1, headerList, dataToDownload);
    const fileName = 'iBoxx_Tradables.ChartData_' +
      ((this.currentPeriod === '3Y' || this.currentPeriod === '5Y' || this.currentPeriod === '10Y') ? '1Y' : this.currentPeriod);
    const URL = this.apiService.createGetPath('/indices/createExcel', ['fileName', fileName]);
    window.open(URL);
    // this.utilService.downloadFile(dataToExport, fileName);
  }

  expandView(cardName: string): void {
    if (this.expanded) {
      this.expanded = false;
      this.visibleCards = ['chart', 'profile', 'analytics', 'constituent'];
    } else {
      this.expanded = true;
      this.currentCard = cardName;
      this.changeView(cardName);
    }
    this.storeView();
  }

  changeView(event: any): void {
    this.visibleCards.splice(0);
    switch (event) {
      case 'CHART':
        this.visibleCards.push('chart');
        break;
      case 'INDEX PROFILE':
        this.visibleCards.push('profile');
        break;
      case 'INDEX PERFORMANCE & ANALYTICS':
        this.visibleCards.push('analytics');
        break;
      case 'CONSTITUENT':
        this.visibleCards.push('constituent');
        break;
    }
    this.storeView();
  }

  repopulateView(): void {
    // @ts-ignore
    JSON.parse(localStorage.getItem('tabViewState')).forEach((view: any) => {
      if (view.tabName === this.currentTab) {
        this.visibleCards = view.state.visibleCards;
        if (this.visibleCards.length === 1) {
          // @ts-ignore
          this.currentCard = this.cards.find((card: string) => {
            if (card.includes(this.visibleCards[0].toUpperCase())) {
              return card;
            }
          });
        }
        if (!this.currentCard) {
          this.currentCard = 'CONSTITUENT';
        }
        this.expanded = view.state.expanded;
      }
    });

    this.chartDataLoaded = false;
    this.profileData = undefined;
    if (this.currentPeriod !== 'custom' && this.currentPeriod !== 'No period selected') {
      this.dateRange = new RangeDateScreenerFilterModel();
    }
  }

  reinitialisePeriodPicker(): void {
    this.period = {
      label: '',
      options: []
    };
    this.period.options.push({
      label: 'No period selected',
      value: 'No period selected',
      selected: true
    });
    this.periodData.forEach((pd: string) => {
      this.period.options.push({
        label: pd,
        value: pd,
        selected: false
      });
    });
  }

  storeView(): void {
    const tabDetails = {
      tabName: this.currentTab,
      state: {
        visibleCards: this.visibleCards,
        expanded: this.expanded
      }
    };
    const index = this.currentView.findIndex((view: any) => view.tabName === tabDetails.tabName);
    if (index > -1) {
      // @ts-ignore
      this.currentView.splice(index, 1, tabDetails);
    } else {
      // @ts-ignore
      this.currentView.push(tabDetails);
    }
    localStorage.setItem('tabViewState', JSON.stringify(this.currentView));
  }

  closeAlert(alert: string): void {
    switch (alert) {
      case 'alert1':
        this.showAlert1 = false;
        break;
      case 'alert2':
        this.showAlert2 = false;
        break;
      case 'alert3':
        this.showAlert3 = false;
        break;
      case 'indexNotFoundMsg':
        this.indexNotInHeadline = false;
        if (this.indexNotFoundMsg === 'Invalid Request.') {
          this.route.navigateByUrl('iBoxx/Screener');
        }
        break;
    }
  }

  storeChartOption(currentId: string, currentPeriod: string, currentTimeSeries: string, toDate: string, fromDate: string,
                   chartType: string, indicesOnChart: string[]): void {
    const options = {
      id: currentId,
      periodType: currentPeriod === 'No period selected' ? 'custom' : currentPeriod,
      timeSeries: currentTimeSeries,
      toDate,
      fromDate,
      chartType,
      indicesOnChart
    };
    const index = this.chartFilters.findIndex((filter: any) => filter.id === this.currentID);
    if (index > -1) {
      // @ts-ignore
      this.chartFilters.splice(index, 1, options);
    } else {
      // @ts-ignore
      this.chartFilters.push(options);
    }
    localStorage.setItem('chartFilterOptions', JSON.stringify(this.chartFilters));
  }

  fetchChartOptions(): void {
    // @ts-ignore
    const filtersValue = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];
    if (filtersValue !== null) {
      filtersValue.forEach((filter: any) => {
        if (filter.id === this.currentID) {
          this.selectedTimeSeries = filter.timeSeries;
          this.selectedPeriod = filter.periodType;
          this.selectedFromDate = filter.fromDate;
          this.selectedToDate = filter.toDate;
          this.currentPeriod = filter.periodType;
          this.currentTimeSeries = filter.timeSeries;
          this.chartType = filter.chartType;
          this.indexToCompare = filter.indicesOnChart;
        }
      });
      this.initialiseDropDown();
      this.initDropDown();
    }
  }

  initTimeSeriesDropDown(): void {
    this.timeSeries.options = [];
    this.timeSeriesData.forEach((ts: string) => {
      this.timeSeries.options.push({
        label: ts,
        value: ts,
        selected: ts === (this.selectedTimeSeries ? this.selectedTimeSeries : this.timeSeriesData[0])
      });
    });
  }

  initCompareChartDropdown(): void {
    this.TRSIndex = this.shareService.headlineIndices.filter((index: any) => (index.investmentType.includes('Standardized_TRS') ||
      index.investmentType.includes('Futures')) && index.id !== this.currentID)
      .sort((ind1: any, ind2: any) => ind1.indexName.toUpperCase() < ind2.indexName.toUpperCase() ? -1 : 1);
    this.compareData.options = [];
    this.TRSIndex.forEach((ts: any) => {
      this.compareData.options.push({
        label: ts.indexName,
        value: ts.indexName,
        selected: false
      });
    });
    setTimeout(() => {
      this.resetDropdown = true;
    }, 10);
  }

  rePopulateTimeSeriesDropDown(): void {
    const indicesOnDropdown = this.indexToCompare.filter((id: string) => id !== this.currentID && id !== '');
    const hasBondIndex = this.TRSIndex.filter((index: any) => indicesOnDropdown.includes(index.id))
      .map((index: any) => index.assetType).includes('bond');

    const timeSeriesForTRS = ['Total Return Index Level', 'Price Return Index Level', 'Total Return Index Level Rebased', 'Price Return Index Level Rebased', 'Coupon (%)'];
    if (this.response.assetType === 'bond') {
      timeSeriesForTRS.splice(2, 0, 'Annual Yield (%)');
    } else {
      timeSeriesForTRS.splice(2, 0, 'Current Yield (%)');
    }
    if (this.response.assetType === 'bond') {
      if (indicesOnDropdown.length > 0) {
        if (hasBondIndex) {
          timeSeriesForTRS.push('Annual Modified Duration', 'Effective Duration',
            'Asset Swap Margin', 'Z-spread (bps)', 'Annual Index Benchmark Spread', 'OAS (bps)');
        }
      } else {
        timeSeriesForTRS.push('Annual Modified Duration', 'Effective Duration',
          'Asset Swap Margin', 'Z-spread (bps)', 'Annual Index Benchmark Spread', 'OAS (bps)');
      }
    }

    this.timeSeries.options = [];
    timeSeriesForTRS.forEach((ts: string) => {
      this.timeSeries.options.push({
        label: ts,
        value: ts,
        selected: ts === (this.currentTimeSeries ? this.currentTimeSeries :
          (this.selectedTimeSeries ? this.selectedTimeSeries : this.timeSeriesData[0]))
      });
    });
  }

  rePopulateCompareIndexDropDown(): void {
    this.resetDropdown = false;
    const selectedIndices = this.TRSIndex.filter((index: any) => this.indexToCompare.includes(index.id))
      .map((index: any) => index.indexName);
    let showLoanIndex = true;
    let showBondIndex = true;
    switch (this.currentTimeSeries) {
      case 'Annual Yield (%)':
        showLoanIndex = false;
        break;
      case 'Current Yield (%)':
        showBondIndex = false;
        break;
      case 'Annual Modified Duration':
        showLoanIndex = false;
        break;
      case 'Effective Duration':
        showLoanIndex = false;
        break;
      case 'Asset Swap Margin':
        showLoanIndex = false;
        break;
      case 'Z-spread (bps)':
        showLoanIndex = false;
        break;
      case 'Annual Index Benchmark Spread':
        showLoanIndex = false;
        break;
      case 'OAS (bps)':
        showLoanIndex = false;
        break;
    }
    this.compareData.options = [];
    let TRSIndex: any[] = [];
    if (showBondIndex) {
      TRSIndex = this.TRSIndex.filter((index: any) => index.assetType === 'bond');
    }
    if (showLoanIndex) {
      TRSIndex.push.apply(TRSIndex, this.TRSIndex.filter((index: any) => index.assetType === 'loan' || index.assetType === 'agg'));
    }
    TRSIndex.forEach((ts: any) => {
      this.compareData.options.push({
        label: ts.indexName,
        value: ts.indexName,
        selected: selectedIndices.includes(ts.indexName)
      });
    });
    setTimeout(() => {
      this.resetDropdown = true;
    }, 10);
  }

  getTabList(): void {
    // @ts-ignore
    const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
      {
        all: [],
        futures: [],
        trs: [],
        esg: [],
      };
    let foundIndexType = 'all';
    Object.keys(tabGroup).forEach((keys: string) => {
      if (tabGroup[keys].includes(this.currentTab)) {
        foundIndexType = keys;
      }
    });
    this.store.dispatch(new SaveStateName(foundIndexType));
    this.tabList = tabGroup[foundIndexType].length > 0 ? tabGroup[foundIndexType] : ['screener', 'documentation'];
    if (!this.tabList.includes(this.currentTab)) {
      this.tabList.push(this.currentTab);
      this.utilService.saveTabListFor(foundIndexType, this.tabList);
    }
    this.indexType = foundIndexType;
  }

  getFileName(currentTimeSeries: string): string{
    return encodeURIComponent(this.response.indexName.replaceAll('/', ' ') + '_' +
        ((this.currentPeriod === '3Y' || this.currentPeriod === '5Y' || this.currentPeriod === '10Y') ? '1Y' : this.currentPeriod)
        + '_' + currentTimeSeries.replace(' (%)', '').replace(' (bps)', '') + '_'
        + (this.response.productName === 'iBoxx Global Inflation-linked' ? this.response.inflationAdjustment : ''));
  }
}
